import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMyModuleCompletionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyModuleCompletionsQuery = { __typename?: 'query_root', learning_module_completions: Array<{ __typename?: 'learning_module_completions', id: number, module_key: string, module_id?: number | null, completed_at: string }> };


export const GetMyModuleCompletionsDocument = gql`
    query GetMyModuleCompletions {
  learning_module_completions(order_by: {completed_at: desc}) {
    id
    module_key
    module_id
    completed_at
  }
}
    `;

/**
 * __useGetMyModuleCompletionsQuery__
 *
 * To run a query within a React component, call `useGetMyModuleCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyModuleCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyModuleCompletionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyModuleCompletionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>(GetMyModuleCompletionsDocument, options);
      }
export function useGetMyModuleCompletionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>(GetMyModuleCompletionsDocument, options);
        }
// @ts-ignore
export function useGetMyModuleCompletionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>;
export function useGetMyModuleCompletionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyModuleCompletionsQuery | undefined, GetMyModuleCompletionsQueryVariables>;
export function useGetMyModuleCompletionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>(GetMyModuleCompletionsDocument, options);
        }
export type GetMyModuleCompletionsQueryHookResult = ReturnType<typeof useGetMyModuleCompletionsQuery>;
export type GetMyModuleCompletionsLazyQueryHookResult = ReturnType<typeof useGetMyModuleCompletionsLazyQuery>;
export type GetMyModuleCompletionsSuspenseQueryHookResult = ReturnType<typeof useGetMyModuleCompletionsSuspenseQuery>;
export type GetMyModuleCompletionsQueryResult = Apollo.QueryResult<GetMyModuleCompletionsQuery, GetMyModuleCompletionsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/learningCenter/queries/getMyModuleCompletions.query.gql}
 */
export async function getMyModuleCompletions(
  variables: GetMyModuleCompletionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMyModuleCompletionsQuery['learning_module_completions']>
export async function getMyModuleCompletions(
  variables: GetMyModuleCompletionsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMyModuleCompletionsQuery>
export async function getMyModuleCompletions(
  variables: GetMyModuleCompletionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMyModuleCompletionsQuery['learning_module_completions'] | GetMyModuleCompletionsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMyModuleCompletionsQuery>(
    GetMyModuleCompletionsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.learning_module_completions
}